









import Vue from "vue";
import { mapState } from "vuex";
import MyTeamsForm from "@/components/MyTeams/MyTeamsForm.vue";
import MyTeamsPlayersListContainer from "@/components/MyTeams/MyTeamsPlayersListContainer.vue";
import { TeamsActionTypes, TeamsState, namespaceTeams } from "@/store/teams";

export default Vue.extend({
  name: "myTeamsEdit",
  components: {
    MyTeamsForm,
    MyTeamsPlayersListContainer
  },
  computed: {
    ...mapState<TeamsState>(namespaceTeams, {
      name: (state: TeamsState) => state.team && state.team.name,
      teamMembers: (state: TeamsState) => state.teamMembers
    })
  },
  methods: {
    submitHandler: async function() {
      await this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.UpdateTeam}`);
    }
  },
  mounted() {
    this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.GetTeam}`, this.$route.params.id);
    this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.GetTeamMembers}`, this.$route.params.id);
  }
});
